import { ArtemisStreamError } from '../../lib/artemis/stream'

// Artemis credit packs through services (API-3799). See lib/artemis/credits.js for the contract,
// which services hasn't built yet: until it does, these answer 404 and the page shows packs with
// buying off.
const servicesJson = async (token, path, { method = 'GET', body } = {}) => {
  const response = await fetch(`${__API_URI__}/${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      Platform: 'Web',
      Version: `${__version__}`,
      ...(body !== undefined && { 'Content-Type': 'application/json' })
    },
    body: body !== undefined ? JSON.stringify(body) : undefined
  })
  if (!response.ok) throw new ArtemisStreamError(`HTTP ${response.status}`, `http_${response.status}`)
  return response.json()
}

// [{ Id, PriceUsd, CreditUsd, ValidDays }]
export const fetchArtemisCreditProducts = () => (dispatch, getState, token) =>
  servicesJson(token, 'Payment/CreditProducts')

// { Url } (services answers { url }): a Stripe Checkout Session for one pack, returning to SuccessUrl or CancelUrl.
export const createArtemisCreditCheckout = (productId, urls) => (dispatch, getState, token) =>
  servicesJson(token, 'Payment/CreditLink', { method: 'POST', body: { ProductId: productId, ...urls } })
